"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_54_2_0 = void 0;
const ManagedConfigurationType_1 = require("../ManagedConfigurationType");
/**
 * Migrate to 54.2.0
 *
 * Stacking of Leitungen is enabled by default for iQuote Configurations [EKE-5668]
 *
 */
const migration_54_2_0 = (json) => {
    if (json.ManagedConfigurationType === ManagedConfigurationType_1.ManagedConfigurationType.IQuote && !json.IsStackingOfLeitungenAllowed) {
        json.IsStackingOfLeitungenAllowed = true;
    }
    return json;
};
exports.migration_54_2_0 = migration_54_2_0;
//# sourceMappingURL=migration_54_2_0.js.map